var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFigure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "figure_svg__figure",
    "data-name": "figure",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1082.2 800.8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "figure_svg__gradient",
    x1: 725.88,
    y1: 797.19,
    x2: 763.27,
    y2: 797.19,
    gradientTransform: "matrix(.99 -.1 -.1 -.99 -.33 969.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccede7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adf6f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "figure_svg__gradient-2",
    x1: 756.11,
    y1: 779.71,
    x2: 793.68,
    y2: 779.71,
    xlinkHref: "#figure_svg__gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "figure_svg__gradient-3",
    x1: 839.23,
    y1: 134.01,
    x2: 911.87,
    y2: 92.3,
    gradientTransform: "matrix(.95 .33 .33 -.95 115.35 188.53)",
    xlinkHref: "#figure_svg__gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "figure_svg__gradient_23",
    x1: 932.47,
    y1: -786.28,
    x2: 944.1,
    y2: -808.59,
    gradientTransform: "matrix(.74 .67 .67 -.74 597.64 -609.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9de1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6dd1eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "figure_svg__gradient_23-2",
    x1: 927.11,
    y1: -761.73,
    x2: 954.99,
    y2: -800.5,
    xlinkHref: "#figure_svg__gradient_23"
  }), /*#__PURE__*/React.createElement("style", null, "@keyframes figure-ani{0%{transform:translateY(0)}50%{transform:translateY(-36px)}}.figure_svg__cls-1{fill:#6dd1eb}.figure_svg__cls-2{fill:#21458e}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      animationName: "figure-ani",
      animationDuration: "3s",
      animationIterationCount: "infinite",
      animationDirection: "alternate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#figure_svg__gradient)",
    d: "M677.8 97.5L658 111.9l-17.1-7.7 19.7-14.6 17.2 7.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__cls-1",
    d: "M657 111.24l20.9-13.74 2.7 27.2-19.8 14.4-3.8-27.86z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__cls-2",
    d: "M660.8 139.1l-2.8-27.2-17.1-7.7 3.1 27.2 16.8 7.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#figure_svg__gradient-2)",
    d: "M709.8 111.8L690 126.2l-17.2-7.7 19.7-14.6 17.3 7.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__cls-1",
    d: "M707.1 113.8l-17.79 12.09 4.59 40.41 19.9-14.4-4-40.1-2.7 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__cls-2",
    d: "M672.8 118.5l4.1 40.1 17 7.7-3.9-40.1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animationDelay: "-2s",
      animationName: "figure-ani",
      animationDuration: "3s",
      animationIterationCount: "infinite",
      animationDirection: "alternate"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#figure_svg__gradient-3)",
    d: "M943.6 335.8l17.2-3.4 49.9 57.4-17.1 3.4-50-57.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__cls-1",
    d: "M1010.8 389.8l-17.2 3.4-4.9 14.3 17.1-3.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__cls-2",
    d: "M988.7 407.5l4.9-14.3-50-57.4-4.9 14.2 13.3 15.3 36.7 42.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      animationDelay: "-1s",
      animationName: "figure-ani",
      animationDuration: "3s",
      animationIterationCount: "infinite",
      animationDirection: "alternate"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M757.8 628.73c-3.13-2.51.19-19.88 3.5-23.7-3.49-6.72-11.79-11-17.19-6.38-6.53 5.57-10.4 19.67-1.71 26.79 3.77 3.09 6.89 2.93 15.4 3.29z",
    fill: "url(#figure_svg__gradient_23)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M775.18 636.69a55.51 55.51 0 008-23.53c.28-4.39.55-10.4-.9-15.5a29.58 29.58 0 00-1.8-4.9c-1.36-2.46-2.92-5.2-5.7-6.8-1.22-1.2-19.28-4.46-21-5 3.91.67 7.09 3.75 9.2 7.9 6.35 12.82 3.61 42.81-15.7 51.9-1.58.46-3.77 1.58-6.2 1.15 4.61.55 18.71 3.92 23.9 2.75 1.31-.3 6.2-1.33 10.2-7.97z",
    fill: "url(#figure_svg__gradient_23-2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__cls-2",
    d: "M765.5 593c-3.4-10.8-11.8-14.7-19.2-10.2-3.4 2.3-5.7 3.9-10.4 12.2-5 8.8-8.2 24.6-4.7 35.4 4.3 13.4 15.4 15.9 24.9 5.6s13.7-29.6 9.4-43zm-25.1 27.1c-1.9-6 0-14.7 4.2-19.3s9.3-3.5 11.2 2.5 0 14.7-4.2 19.3-9.3 3.5-11.2-2.5z"
  }))));
}

export default SvgFigure;